import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  subscriptionPayments: "/subscription-payment",
};

export const fetchSubscriptionPayment = createAsyncThunk(
  "subscriptionPayments/fetchSubscriptionPayments",
  async (
    {
      subscription_id,
      establishment_slug,
    }: { subscription_id: string | number; establishment_slug: string },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.get(
        `${endpoint.subscriptionPayments}/${subscription_id}/${establishment_slug}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createSubscriptionPayment = createAsyncThunk(
  "subscriptionPayments/createSubscriptionPayment",
  async (
    payload: { data: any; subscription_id: string | number },
    thunkAPI,
  ) => {
    try {
      const { data, subscription_id } = payload;
      const response = await axiosInstance.post(
        `${endpoint.subscriptionPayments}/${subscription_id}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
